module.exports = __webpack_public_path__ + "static/img/index_bg.ae644bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_bg.png
// module id = z3Z8
// module chunks = 16